import { useContext } from "react";

import { InstanceContext } from "contexts/InstanceContext";

export const useInstanceData = () => useContext(InstanceContext);
